var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowSwap = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-swap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-swap_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2501 14.9905C21.2501 15.1805 21.1801 15.3705 21.0301 15.5205L16.0201 20.5305C15.7301 20.8205 15.2501 20.8205 14.9601 20.5305C14.6701 20.2405 14.6701 19.7605 14.9601 19.4705L19.9701 14.4605C20.2601 14.1705 20.7401 14.1705 21.0301 14.4605C21.1701 14.6105 21.2501 14.8005 21.2501 14.9905Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.25 14.9902C21.25 15.4002 20.91 15.7402 20.5 15.7402L3.5 15.7402C3.09 15.7402 2.75 15.4002 2.75 14.9902C2.75 14.5802 3.09 14.2402 3.5 14.2402L20.5 14.2402C20.91 14.2402 21.25 14.5802 21.25 14.9902Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.25994 3.99055C9.25994 4.18055 9.18994 4.37055 9.03994 4.52055L4.02994 9.53055C3.73994 9.82055 3.25994 9.82055 2.96994 9.53055C2.67994 9.24055 2.67994 8.76055 2.96994 8.47055L7.97994 3.46055C8.26994 3.17055 8.74994 3.17055 9.03994 3.46055C9.18994 3.61055 9.25994 3.80055 9.25994 3.99055Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.25 9.00977C21.25 9.41977 20.91 9.75977 20.5 9.75977L3.5 9.75977C3.09 9.75977 2.75 9.41977 2.75 9.00977C2.75 8.59977 3.09 8.25977 3.5 8.25977L20.5 8.25977C20.91 8.25977 21.25 8.58977 21.25 9.00977Z",
    fill: "#757575"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowSwap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-swap.323978fb.svg";
export { ForwardRef as ReactComponent };